<main>
  <header>
    <h1>Ownership Disclosure</h1>
    <h2>Do any individuals own 25% or more of the business, or serve as the person who controls or manages the business?</h2>
    <h2 class="italic">U.S. Federal regulation requires us to collect information on individuals who own 25% or more of the business, as well as one control person who has significant responsibility to manage or direct the business. Please identify all individuals with 25% or more ownership and provide information for one control person, even if no individual meets the ownership threshold.</h2>
  </header>

  <form class="application-form" [formGroup]="form" (ngSubmit)="continue()">
    <div class="field">
      <label for="noIndividualOver25">Ownership Status</label>
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-select formControlName="noIndividualOver25" required placeholder="Enter" (selectionChange)="onOwnershipChange($event)">
          <mat-option *ngFor="let option of ownershipOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('noIndividualOver25')?.hasError('required')">
          Please select an option
        </mat-error>
      </mat-form-field>
      <!--
      @if (form.get('noIndividualOver25')?.value === 'yes') {
        <p class="field-info">
          U.S. Federal regulation requires us to collect information on individuals who own 25% or more of the business, as well as one control person who has significant responsibility to manage or direct the business. Please identify all individuals with 25% or more ownership and provide information for one control person, even if no individual meets the ownership threshold.
        </p>
      }
      -->
    </div>

    <app-form-actions
      [isFormInvalid]="form.invalid"
      (continue)="continue()"
      (back)="goBack()"
    >
    </app-form-actions>
  </form>
</main>